const breakpoints = {
  values: {
    xs: 0,
    sm: 769,
    md: 1025,
    lg: 1200,
    xl: 1536
  }
};

export default breakpoints;
